import { Injectable } from '@angular/core';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { FormService } from '../services/form.service';
import { SetArrayToQueryParams } from './CommonFunctions';
import { OrderType, PatientType } from './KRollConstants';
import { HelperService } from 'src/app/core/services/helper.service';
@Injectable({
  providedIn: 'root',
})
export class RouteConstants {

  orderStatusIds: number[] = [];
  public DraftOrder: any;
  public RequestedOrder: any;
  public SalesOrder: any;
  public ProcessedOrder: any;
  tenant: any = localStorage.getItem('tenant')
  // see a doctor start
  public createUserAppointment = {
    AppointmentAdd: {
      Route: '/portal/appointmentAdd',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public doctorAppointments = {
    doctorAppointments: {
      Route: '/portal/doctorAppointments',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  // see a doctor end

  public Prescriptions = {
    PrescriptionsList: {
      Route: '/portal/prescriptions',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public ShellEprescriptions = {
    PrescriptionsList: {
      Route: '/portal/shell-eprescriptions',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public DialogueEprescription = {
    PrescriptionsList: {
      Route: '/portal/dialogue-eprescriptions',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public DialogueAndShellEprescription = {
    PrescriptionsList: {
      Route: '/portal/shell-and-dialogue-eprescriptions',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public TransferPrescriptions = {
    TransferPrescriptionsList: {
      Route: '/portal/transfer-prescriptions',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public RecentPayments = {
    RecentPaymentsList: {
      Route: '/portal/recent-payments',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public PendingPayments = {
    PendingPaymentsList: {
      Route: '/portal/pending-payments',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public Users = {
    UsersList: {
      Route: '/portal/users',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersMedications: {
      Route: '../../patient/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersDetail: {
      Route: '/portal/users/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    Patient: {
      Route: '../../patient/detail/',
    },
    PatientAccountSwitch: {
      Route: '/patient/detail/',
    },
    BroadcastingMessage: {
      Route: '/portal/users/broadcasting-message',
    },
    DeletionRequest: {
      Route: '/portal/users/deletion-request',
    },
  };
  public ShellUsers = {
    UsersList: {
      Route: '/portal/shell-users',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersMedications: {
      Route: '/portal/shell-users',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public PreAssessment = {
    PreAssessmentList: {
      Route: '/portal/pharmacist-consultation',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    PreAssessmentDetail: {
      Route: '/pharmacist-consultation-dashboard/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    PreAssessmentForm: {
      Route: '/pharmacist-consultation-dashboard/pre-assessment-form/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public HealthCarePlanRoute = {
    HealthCarePlanList: {
      Route: '/portal/health-care-plans',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public DrugsRoute = {
    DrugsList: {
      Route: '/portal/drugs-list',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
   public RxPrescriptionRoute = {
    RxList: {
      Route: '/portal/p-exchange-prescription',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public RingCentralPrescriptionRoute = {
    RingCentralList: {
      Route: '/portal/ring-central-prescription',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public TakeHomeSummary = {
    TakeHomeSummaryList: {
      Route: '/portal/take-home-summary',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public HealthProgramRoute = {
    HealthProgramList: {
      Route: '/portal/health-programs',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public RenewRefill = {
    UsersList: {
      Route: '/portal/renew-refill',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    RenewRefillRequest: {
      Route: '/portal/renew-refill',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    ViewAllNotifications: {
      Route: '/portal/view-all-notifications',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public Settings = {
    OnHoldReasonList: {
      Route: '/portal/settings/reason/on-hold',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    CanceledReasonList: {
      Route: '/portal/settings/reason/canceled',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    TransferReasonList: {
      Route: '/portal/settings/reason/transferred',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UserDeleteReasonList: {
      Route: '/portal/settings/reason/user-delete',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    CouriersList: {
      Route: '/portal/settings/couriers',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    AppointmentPlatformList: {
      Route: '/portal/settings/appointment-platform',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    ReferralCodeList: {
      Route: '/portal/settings/referral-code',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    DaylightSaving: {
      Route: '/portal/settings/daylight-saving',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    Features: {
      Route: '/portal/settings/features',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    PatientGroup: {
      Route: '/portal/settings/patient-group',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    PexchangePartners: {
      Route: '/portal/settings/platform',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    MessageTemplateList: {
      Route: '/portal/settings/message-template',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    BasicSettings: {
      Route: '/portal/settings/basic-settings',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public IntakeForms = {
    UsersList: {
      Route: '/portal/intake-forms',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };
  public FeatureFlag = {
    Route: '/portal/feature-flag',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public Survey = {
    Route: '/portal/appointment',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public Consent = {
    Route: '/portal/consent',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public PromoCode = {
    Route: '/portal/promo-code',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public AdditionalCoverage = {
    Route: '/portal/additional-coverage',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public Report = {
    Route: '/portal/report',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public DetailReport = {
    Route: '/portal/report',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public DiabetesSnapshotReport = {
    Route: '/portal/report/diabetes-snapshot-report',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };

  public Dashbaord = {
    Route: '/portal/dashboard',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public TaskManagement = {
    Route: '/portal/task-management',
    QueryParams: { page: 1, per_page: 10, search: '' },
  };
  public Staff = {
    StaffList: {
      Route: '/portal/staff',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersDetail: {
      Route: '/portal/staff/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
  };

  public Visits = {
    VistList: {
      Route: '/portal/visits',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersMedications: {
      Route: '/visits/dashboard/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    UsersDetail: {
      Route: '/portal/users/detail/',
      QueryParams: { page: 1, per_page: 10, search: '' },
    },
    Patient: {
      Route: '../../patient/detail/',
    },
    PatientAccountSwitch: {
      Route: '/patient/detail/',
    },
    BroadcastingMessage: {
      Route: '/portal/users/broadcasting-message',
    },
    DeletionRequest: {
      Route: '/portal/users/deletion-request',
    },
  };

  constructor(public formService: FormService, public helperService: HelperService) {
    this.DraftOrder = {       
        Route: '/portal/shipping/draft-orders',
        QueryParams: {
          page: 1,
          per_page: 10,
          type: '',
          server_location: this.helperService.getServerLocation(),
          order_status: 1,
        }          
    };
    this.RequestedOrder = {       
        Route: '/portal/shipping/requested-orders',
        QueryParams: {
          page: 1,
          per_page: 10,
          type: '',
          server_location: this.helperService.getServerLocation(),
          order_status: 1,
        }          
    };
    this.SalesOrder = {
      Create: {
        Route: '/portal/shipping/create',
        QueryParams: {},
      },
      SalesOrder: {
        Route: '/portal/shipping',
        QueryParams: {
          page: 1,
          per_page: 10,
          type: this.tenant == 'wylo' ? PatientType.Acute : PatientType.Chronic,
          server_location: this.helperService.getServerLocation(),
          order_status: this.orderStatusIds,
        },
      },
      CreateWithVId: {
        Route: '/portal/shipping/create/:vid',
        QueryParams: {},
      },
    };
    this.ProcessedOrder = {
      Create: {
        Route: '/portal/shipping/create',
        QueryParams: {
          page: 1,
          per_page: 10,
          type: PatientType.Chronic,
          server_location: this.helperService.getServerLocation(),
        },
      },
      ProcessedOrder: {
        Route: '/portal/orders',
        QueryParams: {
          page: 1,
          per_page: 10,
          order_type: OrderType.Active,
          server_location: this.helperService.getServerLocation(),
          order_status: this.orderStatusIds,
        },
      },
    };

    this.formService.selectedLocation.valueChanges
      .pipe(distinctUntilChanged(), throttleTime(1000))
      .subscribe((val: any) => {

        this.SalesOrder.SalesOrder.QueryParams.server_location = this.helperService.getServerLocation();
        //this.ProcessedOrder.Create.QueryParams.server_location = val;
        this.ProcessedOrder.Create.QueryParams.server_location = this.helperService.getServerLocation();
        this.ProcessedOrder.ProcessedOrder.QueryParams.server_location = this.helperService.getServerLocation();
      });
    this.formService.saleOrderForm['controls'].salesOrderStatus.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((val: any) => {
        this.setSaleOrderValue(val);
      });

    this.formService.processedOrderForm[
      'controls'
    ].processedOrderStatus.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((val: any) => {
        this.setProcessedOrderValue(val);
      });
  }
  setSaleOrderValue(val: any) {
    this.SalesOrder.SalesOrder.QueryParams.order_status = SetArrayToQueryParams(
      val.filter((f: any) => f.isChecked).map((m: any) => m.id)
    );
    this.orderStatusIds = SetArrayToQueryParams(
      val.filter((f: any) => f.isChecked).map((m: any) => m.id)
    );
  }
  setProcessedOrderValue(val: any) {
    this.ProcessedOrder.ProcessedOrder.QueryParams.order_status =
      SetArrayToQueryParams(
        val.filter((f: any) => f.isChecked).map((m: any) => m.id)
      );
    this.orderStatusIds = SetArrayToQueryParams(
      val.filter((f: any) => f.isChecked).map((m: any) => m.id)
    );
  }
}
